import React from "react";

const Library = () => (
  <svg width="22" height="18" viewBox="1 2.5 22 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill="#fff" d="M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V6h5.17l2 2H20v10zm-5-5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm-4 4h8v-1c0-1.33-2.67-2-4-2s-4 .67-4 2v1z" fillOpacity=".87" />
  </svg>
);

export default Library;
